import React, { lazy, Suspense } from 'react';

const Bar = lazy(() => import('./general/scale-loader-bar'));
const AdminBar = lazy(() => import('./general/admin-scale-loader-bar'));

export const ScaleLoader = () => (
  <div>
    <Suspense fallback={null}>
      <Bar rank={1} />
      <Bar rank={2} />
      <Bar rank={3} />
      <Bar rank={4} />
      <Bar rank={5} />
    </Suspense>
  </div>
);

export const AdminScaleLoader = () => (
  <>
    <Suspense fallback={null}>
      <AdminBar rank={1} />
      <AdminBar rank={2} />
      <AdminBar rank={3} />
    </Suspense>
  </>
);
